import styled from 'styled-components'

const StyledFooter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: saturate(180%) blur(20px);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  border-top: 1px solid ${({ theme }) => theme.color.gray[300]};
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ theme }) => theme.elevation.fixed};

  .footer {
    height: 80px;
    width: 100%;
    box-sizing: border-box;
    gap: 10px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      width: 100%;
      border-radius: 50rem;
      height: 60px;
      background-color: gainsboro;
      display: grid;
      justify-content: center;
      align-content: center;
      justify-items: center;
      text-decoration: none;
      font-weight: 700;
      gap: 10px;
      font-size: 10px;
      letter-spacing: 1px;
      background-color: transparent;
      color: ${({ theme }) => theme.color.gray[900]}50;

      svg {
        height: 24px;
        stroke-width: 2.5px;
      }

      &.active {
        color: ${({ theme }) => theme.color.gray[900]};
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    display: none;
  }
`

export default StyledFooter
